import { FAILED, LOADING, SUCCESS, ACTION } from './constants';

export const initialState = {
  dataAreaManagement: {
    data: [],
    meta: {
      page: 1,
      totalPage: 1,
      totalData: 0,
    },
  },
  dataSubmitAreaManagement: false,
  dataSubmitUpdateAreaManagement: false,
  isLoadingSubmitAreaManagement: false,
  isLoadingAreaManagement: false,
  isLoadingSubmitUpdateAreaManagement: false,
  messageSubmitAreaManagement: '',
  messageSubmitUpdateAreaManagement: '',
  messageAreaManagement: '',
  action: '',
};

export default function reducer(state = initialState, action) {
  const { type, data, isLoading, message, key } = action;
  switch (type) {
    case FAILED:
      return {
        ...state,
        [`data${key}`]: initialState[`data${key}`],
        [`isLoading${key}`]: false,
        [`message${key}`]: message,
      };
    case LOADING:
      return {
        ...state,
        [`isLoading${key}`]: isLoading,
        [`message${key}`]: '',
      };
    case SUCCESS:
      return {
        ...state,
        [`data${key}`]: data,
        [`isLoading${key}`]: false,
        [`message${key}`]: message,
      };
    case ACTION:
      return {
        ...state,
        action: data,
      };
    default:
      return state;
  }
}
